import { IPopupModelV2 } from '@mwe/models';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
  selector: 'mwe-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, TranslatePipe, ButtonComponent],
})
export class ModalComponent {
  private activeModal = inject(NgbActiveModal);
  model = input.required<IPopupModelV2>();

  cancel(): void {
    this.activeModal.close('CANCEL');
  }
}
